export default __webpack_public_path__ + "images/referenzen/animationsfilm/olympus_nbi_productfilm.mp4";